/**
 * CIPAA Filters Component
 * Inline filter bar: filters stay visible and apply live (no popover).
 */

import React from 'react';
import { InlineFilterBar, InlineMultiSelect } from '../../../components/common';
import { useFilterState } from '../../../hooks/useFilterState';
import { CipaaStatus, CIPAA_STATUS_LABELS } from '../../../types/cipaa';

export interface CipaaFiltersData {
  search: string;
  status: string[];
}

interface CipaaFiltersProps {
  onFilter: (filters: CipaaFiltersData) => void;
  loading?: boolean;
  total?: number;
}

const STATUS_OPTIONS = Object.values(CipaaStatus).map((s) => ({
  value: s,
  label: CIPAA_STATUS_LABELS[s],
}));

const defaultValues: CipaaFiltersData = {
  search: '',
  status: [],
};

export const CipaaFilters: React.FC<CipaaFiltersProps> = ({
  onFilter,
  loading = false,
  total,
}) => {
  const { filters, setFilter, clearAll, activeChips } = useFilterState(defaultValues, {
    onFilter,
    applyOnMount: true,
    live: true,
    labels: {
      status: 'Status',
    },
    formatValue: {
      status: (v: string[]) =>
        v.map((s) => CIPAA_STATUS_LABELS[s as CipaaStatus] ?? s).join(', '),
    },
  });

  return (
    <InlineFilterBar
      searchPlaceholder="Nome da eleição..."
      searchValue={filters.search}
      onSearchChange={(v) => setFilter('search', v)}
      resultCount={total}
      resultNoun="eleições"
      chips={activeChips}
      onClearAll={clearAll}
      loading={loading}
    >
      <InlineMultiSelect
        label="Status"
        value={filters.status}
        options={STATUS_OPTIONS}
        onChange={(v) => setFilter('status', v)}
        minWidth={220}
        disabled={loading}
      />
    </InlineFilterBar>
  );
};

export default CipaaFilters;
